if (!customElements.get('free-delivery-badge')) {
  customElements.define(
    'free-delivery-badge',
    class FreeDeliveryBadge extends HTMLElement {
      constructor() {
        super();
        this.productInfo = this.closest('product-info');
        this.badge = this.querySelector('.badge');
      }
      connectedCallback() {
        if (this.rawData == null) {
          return this.classList.add('hidden');
        }
        try {
          this.data = JSON.parse(this.rawData.innerText);
          this.renderBadge();
        } catch (e) {
          console.error(e);
          return this.classList.add('hidden');
        }
      }
      get price() {
        return this.dataset.price;
      }
      get rawData() {
        return document.querySelector('[data-free-delivery-data]');
      }
      async renderBadge() {
        if (this.productInfo.dataset.country == null) {
          let response = await fetch(`/browsing_context_suggestions.json`);
          let data = await response.json();
          let country = data.detected_values.country.handle;
          this.productInfo.dataset.country = country;
        }
        let country = this.productInfo.dataset.country;
        let applicableGroup = this.data.freeDeliveryGroups.find((group) => group.countries.includes(country));
        if (applicableGroup != undefined) {
          let cutoff = applicableGroup.cutoff * 100;
          if (parseInt(this.price) > cutoff) {
            this.badge.classList.remove('hidden');
          } else {
            this.badge.classList.add('hidden');
          }
        }
      }
    }
  );
}
